import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "App-User-Skills" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  "m-tb-0": "",
  round: "",
  "f-w-700": ""
}
const _hoisted_5 = { "mute-secondary": "" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  "m-t-3": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_app_section_divider = _resolveComponent("app-section-divider")!
  const _component_StartupExperience = _resolveComponent("StartupExperience")!
  const _component_app_user_section = _resolveComponent("app-user-section")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isTalent)
      ? (_openBlock(), _createBlock(_component_app_user_section, { key: 0 }, {
          default: _withCtx(() => [
            (_ctx.isSelf || _ctx.user.areaOfExpertise)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_app_section_divider, { content: "Expertise" }, _createSlots({
                    default: _withCtx(() => [
                      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "el-icon-s-opportunity" }, null, -1))
                    ]),
                    _: 2
                  }, [
                    (_ctx.isSelf)
                      ? {
                          name: "action",
                          fn: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editAreaOfExpertise())),
                              class: "el-icon-edit",
                              circle: "",
                              size: "mini"
                            })
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1024),
                  _createElementVNode("div", null, [
                    _createVNode(_component_StartupExperience, { user: _ctx.user }, null, 8, ["user"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_app_user_section, null, {
      default: _withCtx(() => [
        (_ctx.isSelf || _ctx.showSkillsSection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_app_section_divider, { content: "Main Skills" }, _createSlots({
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "el-icon-user" }, null, -1))
                ]),
                _: 2
              }, [
                (_ctx.isSelf)
                  ? {
                      name: "action",
                      fn: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editSkills())),
                          class: "el-icon-edit",
                          circle: "",
                          size: "mini"
                        })
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1024),
              _createElementVNode("div", null, [
                _createVNode(_component_el_space, {
                  alignment: "flex-start",
                  direction: "vertical",
                  size: 12
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.skills, (skill, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${index}-${skill._id}`
                      }, [
                        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$filters.capitalize(skill.name.join(", "))), 1),
                        _createElementVNode("span", _hoisted_5, " (" + _toDisplayString(skill.years) + " years of experience) ", 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (
            _ctx.isTalent &&
            (_ctx.isSelf || _ctx.showInterestsSection) &&
            _ctx.user.otherSkills !== undefined &&
            _ctx.user.otherSkills.length > 0
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_app_section_divider, { content: "Other Skills & Passions" }, _createSlots({
                      default: _withCtx(() => [
                        _cache[5] || (_cache[5] = _createElementVNode("i", { class: "el-icon-user" }, null, -1))
                      ]),
                      _: 2
                    }, [
                      (_ctx.isSelf)
                        ? {
                            name: "action",
                            fn: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editAreaOfExpertise())),
                                class: "el-icon-edit",
                                circle: "",
                                size: "mini"
                              })
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1024),
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_space, {
                        wrap: "",
                        size: 12
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.otherSkills, (otherSkill, index) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: `${index}-${otherSkill}`,
                              round: "",
                              "is-borderless": ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(otherSkill), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.interests, (interest, index) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: `${index}-${interest}`,
                              "tag-default": "",
                              round: "",
                              "is-borderless": ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(interest), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}